import { Colors, Lightning, Router, Utils } from '@lightningjs/sdk';
import { checkActivation } from '../../../api/device';
export default class LoginOnline extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      plinko: true,
      Logo: {
        x: (1920 - 470) / 2,
        y: 150,
        texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 470, 67),
      },
      Title: {
        x: 745,
        y: 310,
        w: 410,
        h: 88,
        text: {
          text: 'Log in online',
          textColor: Colors('#FAFAFA').get(),
          fontFace: 'OpenSans-Regular',
          fontSize: 38,
          lineHeight: 78,
          textAlign: 'center',
        },
      },
      Description: {
        x: 589,
        y: 420,
        w: 744,
        h: 79,
        text: {
          textAlign: 'center',
          text: 'Visit the URL below on a computer or mobile device and enter your activation code to continue.',
          textColor: Colors('#FAFAFA').get(),
          fontFace: 'OpenSans-Regular',
          fontSize: 31,
          lineHeight: 37,
        },
      },
      TextLink: {
        x: 813,
        y: 549,
        w: 296,
        h: 65,
        text: {
          text: 'bit.ly/lsstart',
          textColor: Colors('#02AC25').get(),
          fontFace: 'OpenSans-SemiBold',
          fontSize: 48,
          lineHeight: 48,
          letterSpacing: 1.2,
        },
      },
      CodeBorder: {
        x: 567,
        y: 663,
        w: 786,
        h: 145,
        rect: true,
        texture: Lightning.Tools.getRoundRect(786, 138, 13, 3, Colors('#D6D6D6').get(), false),
        Text: {
          x: 125,
          y: 7,
          text: {
            textColor: Colors('#FAFAFA').get(),
            fontFace: 'OpenSans-SemiBold',
            fontSize: 100,
            lineHeight: 100,
            letterSpacing: 30,
            textAlign: 'center',
            verticalAlign: 'middle',
          },
        },
      },
      BtnContainer: {
        collision: true,
        x: 760,
        y: 848,
        w: 400,
        h: 61,
        rect: true,
        color: Colors('#707070').get(),
        shader: { type: Lightning.shaders.RoundedRectangle, radius: 12 },
        EmailLoginBtn: {
          Text: {
            y: 14,
            x: 70,
            text: {
              text: 'Or log in with Email',
              textColor: Colors('#FFFFFF').get(),
              fontFace: 'OpenSans-SemiBold',
              fontSize: 28,
              lineHeight: 34,
            },
          },
        },
      },
    };
  }

  set token(val) {
    return (this._token = val);
  }

  get _EmailLoginBtn() {
    return this.tag('EmailLoginBtn');
  }

  _firstActive() {
    this._setState('EmailLoginBtn');
  }

  _handleBack() {
    clearInterval(this._interval);
    Router.back();
  }

  _active() {
    this.tag('Text').patch({
      text: {
        text: this._token,
      },
    });
    this._checkActivation(this._token);
  }

  _focus() {
    super._focus();
    this._EmailLoginBtn.patch({
      texture: Lightning.Tools.getRoundRect(396, 59, 12, 4, Colors('#02AC25').get(), false),
    });
  }

  _handleEnter() {
    clearInterval(this._interval);
    Router.navigate('login-with-email');
  }

  _handleHover() {
    this._focus();
  }

  _handleClick() {
    this._handleEnter();
  }

  _checkActivation(token) {
    this._interval = setInterval(() => {
      checkActivation(token).then(({ data }) => {
        if (data.success) {
          localStorage.setItem('userToken', data.user.token);
          Router.navigate('profile');
          clearInterval(this._interval);
        }
      });
    }, 5000);
  }
}
